import { useEffect } from 'react'

/**
 * Ensures the darkreader-lock meta tag exists in the document head.
 * This uses Dark Reader's official API to disable Dark Reader on the site.
 *
 * @see https://github.com/darkreader/darkreader/blob/main/CONTRIBUTING.md#disabling-dark-reader-on-your-site
 *
 * This hook should be used in any component that needs to ensure light mode
 * (e.g., onboarding flows, design editors, etc.)
 */
export const useDarkReaderLock = () => {
  useEffect(() => {
    if (!document.querySelector('meta[name="darkreader-lock"]')) {
      const lock = document.createElement('meta')
      lock.name = 'darkreader-lock'
      document.head.appendChild(lock)
    }
  }, [])
}
